export const SERVICE_TERM = `제1조 (목적)
본 약관은 Otterbrick 서비스(이하 "서비스")의 이용조건 및 절차에 관한 사항을 규정함을 목적으로 합니다.

제2조 (정의)
1. "서비스"란, 뉴스레터 모아보기, 콘텐츠 대시보드 제공 등의 기능을 제공하는 웹사이트를 의미합니다.
2. "이용자"란, 본 약관에 따라 서비스를 이용하는 사람을 말합니다.

제3조 (약관의 효력 및 변경)
1. 본 약관은 서비스 화면에 게시하거나 기타 방법으로 이용자에게 공지함으로써 효력을 가집니다.
2. 운영자는 필요하다고 판단되는 경우, 관련 법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있습니다.

제4조 (서비스 제공 및 중단)
1. 본 서비스는 별도 회원가입 없이 구글, 애플, 네이버, 카카오 계정을 통해 이용할 수 있습니다.
2. 운영자는 시스템 유지보수, 보안 등 필요시 서비스 제공을 일시 중단할 수 있습니다.

제5조 (면책조항)
1. 운영자는 무료로 제공되는 서비스와 관련하여 손해에 대해 책임을 지지 않습니다.
2. 이용자의 기기, 네트워크 환경 문제로 인한 손해에 대해서는 책임지지 않습니다.

제6조 (지적재산권)
서비스에 포함된 콘텐츠 및 코드의 저작권은 운영자에게 있으며, 무단 복제, 배포를 금합니다.

제7조 (준거법)
본 약관은 대한민국 법률에 따라 해석됩니다.

부칙
본 약관은 2025년 5월 1일부터 시행합니다.`;

export const INFORMATION_TERM = `Otterbrick 개인정보처리방침

본 방침은 이용자의 개인정보를 보호하기 위해 다음과 같은 내용을 포함합니다.

1. 수집하는 개인정보 항목  
- 소셜 로그인(구글, 애플, 네이버, 카카오 등)을 통해 이메일 주소, 이름(닉네임)이 수집될 수 있습니다.  
- 서비스 이용 중 저장되는 뉴스레터 내용, 개인 설정 등은 로그인된 사용자 기준으로 저장됩니다.

2. 개인정보 수집 및 이용 목적  
- 로그인 기능 제공  
- 개인화된 콘텐츠 제공  
- 서비스 운영 및 유지관리

3. 보유 및 이용 기간  
- 수집된 개인정보는 이용자가 계정을 삭제하거나, 서비스가 종료될 때까지 보관됩니다.

4. 개인정보의 제3자 제공  
- 운영자는 이용자의 개인정보를 제3자에게 제공하지 않습니다.

5. 개인정보 보호 책임자  
- 이메일: info@otterbrick.com

6. 정책 변경 시 고지  
- 본 방침은 2025년 5월 1일부터 적용됩니다. 변경 시 서비스 화면에 공지합니다.`;

export const MARKETING_TERM = `[마케팅 정보 수신 동의] (선택)

Otterbrick 서비스는 이벤트, 기능 업데이트, 뉴스레터 관련 소식을 이메일을 통해 알려드릴 수 있습니다.

• 수신 목적: 이벤트/혜택 안내, 새로운 기능 소개, 콘텐츠 추천 등  
• 수신 방법: 이메일 발송  
• 보유 기간: 수신 동의 철회 시 또는 서비스 종료 시까지

※ 본 동의는 마케팅 목적의 정보 수신에만 사용되며, 언제든지 수신 거부할 수 있습니다.  
※ 서비스 이용에는 영향을 미치지 않습니다. (선택 동의)

동의하시면 이메일을 통해 Otterbrick의 소식을 받아보실 수 있습니다.`;

export const ACCOUNT_TERM = `Otterbrick 계정관리방침

본 방침은 이용자의 계정 및 데이터 관리를 위해 다음과 같은 내용을 포함합니다.

1. 수집되는 데이터
- 이메일 주소, 닉네임 등 계정 정보
- 학습 기록, 진도, 설정 등 서비스 이용 데이터

2. 데이터 사용 및 공유
- 수집된 데이터는 서비스 제공 및 개선 목적으로만 사용됩니다.
- 이용자의 동의 없이 제3자와 데이터를 공유하지 않습니다.
- 법적 요구가 있는 경우에 한해 관련 기관에 제공될 수 있습니다.

3. 데이터 수정 요청
- 이용자는 언제든지 자신의 계정 정보를 수정할 수 있습니다.
- 수정 요청 방법: info@otterbrick.com 으로 이메일 발송
- 수정 요청 시 처리 기간: 영업일 기준 7일 이내

4. 계정 및 데이터 삭제 요청
- 이용자는 언제든지 계정 및 관련 데이터의 삭제를 요청할 수 있습니다.
- 삭제 요청 방법: info@otterbrick.com 으로 이메일 발송
- 삭제 요청 시 처리 기간: 영업일 기준 7일 이내
- 삭제 시 복구 불가: 삭제된 계정과 데이터는 영구 삭제되며 복구할 수 없습니다.

5. 계정관리 책임자
- 이메일: info@otterbrick.com

6. 정책 변경 시 고지
- 본 방침은 2025년 5월 1일부터 적용됩니다. 변경 시 서비스 화면에 공지합니다.`;

export const MOASHELF = {
  PROVIDER_DESCRIPTION_NOTIFICATION: '🙂 소개글을 작성할 예정입니다.',
  SUBSCRIPTION_PAGE_NOTIFICATION: '🙂 구독페이지를 첨부할 예정입니다.',
};
